import ChannelCard from "../../Utilities/ChannelCard";
import logoYoutube from "../../../../../images/logos/logo_youtube.svg";
import useYoutubeSetup from "./useYoutubeSetup";

export default function YoutubeProvider() {
    const {initiateYouTubeSetup} = useYoutubeSetup();

    return(
        <ChannelCard
            icon={logoYoutube}
            label={'YouTube'}
            description={'Get social support and moderation, and engage potential customers with organic comments on relevant videos'}
            onClick={initiateYouTubeSetup}
        />
    )
}